import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { FakeDropdown } from '@/components/FakeDropdown/FakeDropdown';
import { debounce } from 'lodash';

import BiggerPicture from 'bigger-picture';
import { type BiggerPictureInstance } from 'bigger-picture';
import "bigger-picture/css";

@Component
export class GalleryFilter extends ThemeComponent {
    @Ref({ required: false }) filterOne!: HTMLDivElement;
    @Ref({ required: false }) filterTwo!: HTMLDivElement;
    @Ref({ required: false }) filterThree!: HTMLDivElement;
    @Ref({ required: false }) fakeDropdown!: FakeDropdown[];
    @Ref({ required: false }) input!: HTMLInputElement[];

    private bp!: BiggerPictureInstance;
    private imageLinks!: NodeListOf<HTMLAnchorElement>;

    init() {
        // Set initial lightbox images to all images (unfiltered)
        this.imageLinks = this.querySelectorAll('.gallery__image:not(.hidden)');

        // Initialize the image lightbox
        this.bp = BiggerPicture({
            target: document.body,
        });

        // Add a click listener to each image
        for (const link of this.imageLinks) {
            this.$listen(link, "click", (event) => {
                this.openGallery(event);
            });
        }

        // Filter images when the dropdown is changed
        for (const dropdown of this.fakeDropdown) {
            this.$subscribe(dropdown.onChange, debounce(
                () => {
                    this.filterChange();
                }, 300
            ));
        }

    }

    //  Open the image lightbox
    openGallery(event: Event) {
        event.preventDefault();
        if (event.currentTarget) {
            this.bp.open({
                items: this.imageLinks,
                el: event.currentTarget
            });
        }
    }

    filterChange() {
        // Get all filter values
        const filterValues = this.input.map((input) => ({
            name: `${input.name}`,
            value: `${input.value}`
        }));

        for (const image of this.imageLinks) {
            // If a filter value does not match the corresponding data attribute, hide the image
            for (const filter of filterValues) {
                if (
                    filter.value != 'All' &&
                    filter.value != '' &&
                    image.dataset[`${filter.name}`] != filter.value
                ) {
                    image.classList.add('hidden');
                    break;
                }
                // Otherwise show it
                image.classList.remove('hidden');
            }
        }
        // Reassign the images to show in the lightbox
        this.imageLinks = this.querySelectorAll('.gallery__image:not(.hidden)');
    }
}
